var SpanLeaf;

SpanLeaf = (function() {
  function SpanLeaf(children1) {
    var each, j, len, length, ref;
    this.children = children1;
    this.indexParent = null;
    length = 0;
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      each.indexParent = this;
      length += each.getLength();
    }
    this.length = length;
  }

  SpanLeaf.prototype.clone = function() {
    var children, each, j, len, ref;
    children = [];
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      children.push(each.clone());
    }
    return new this.constructor(children);
  };


  /*
  Section: Characters
   */

  SpanLeaf.prototype.getLength = function() {
    return this.length;
  };

  SpanLeaf.prototype.getString = function() {
    var each, j, len, ref, strings;
    strings = [];
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      strings.push(each.getString());
    }
    return strings.join('');
  };

  SpanLeaf.prototype.getLocation = function(child) {
    var each, j, len, length, ref, ref1;
    length = ((ref = this.indexParent) != null ? ref.getLocation(this) : void 0) || 0;
    if (child) {
      ref1 = this.children;
      for (j = 0, len = ref1.length; j < len; j++) {
        each = ref1[j];
        if (each === child) {
          break;
        }
        length += each.getLength();
      }
    }
    return length;
  };


  /*
  Section: Spans
   */

  SpanLeaf.prototype.getSpanCount = function() {
    return this.children.length;
  };

  SpanLeaf.prototype.getSpan = function(index) {
    return this.children[index];
  };

  SpanLeaf.prototype.getSpanIndex = function(child) {
    var index, ref;
    index = ((ref = this.indexParent) != null ? ref.getSpanIndex(this) : void 0) || 0;
    if (child) {
      index += this.children.indexOf(child);
    }
    return index;
  };

  SpanLeaf.prototype.getSpanInfoAtLocation = function(location, spanIndex, spanLocation) {
    var childLength, each, j, len, ref;
    if (spanIndex == null) {
      spanIndex = 0;
    }
    if (spanLocation == null) {
      spanLocation = 0;
    }
    ref = this.children;
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      childLength = each.getLength();
      if (location > childLength) {
        location -= childLength;
        spanIndex++;
        spanLocation += childLength;
      } else {
        return {
          span: each,
          location: location,
          spanIndex: spanIndex,
          spanLocation: spanLocation
        };
      }
    }
  };

  SpanLeaf.prototype.iterateSpans = function(start, count, operation) {
    var i, j, ref, ref1;
    for (i = j = ref = start, ref1 = start + count; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
      if (operation(this.children[i]) === false) {
        return false;
      }
    }
  };

  SpanLeaf.prototype.insertSpans = function(index, spans) {
    var each, j, len;
    for (j = 0, len = spans.length; j < len; j++) {
      each = spans[j];
      each.indexParent = this;
      this.length += each.getLength();
    }
    return this.children = this.children.slice(0, index).concat(spans).concat(this.children.slice(index));
  };

  SpanLeaf.prototype.removeSpans = function(start, removeCount) {
    var each, end, i, j, ref, ref1;
    end = start + removeCount;
    for (i = j = ref = start, ref1 = end; ref <= ref1 ? j < ref1 : j > ref1; i = ref <= ref1 ? ++j : --j) {
      each = this.children[i];
      each.indexParent = null;
      this.length -= each.getLength();
    }
    return this.children.splice(start, removeCount);
  };


  /*
  Section: Util
   */

  SpanLeaf.prototype.collapse = function(spans) {
    var each, j, len, ref, results;
    ref = this.children;
    results = [];
    for (j = 0, len = ref.length; j < len; j++) {
      each = ref[j];
      results.push(spans.push(each));
    }
    return results;
  };

  return SpanLeaf;

})();

module.exports = SpanLeaf;



/*****************
 ** WEBPACK FOOTER
 ** ./lib/span-buffer/span-leaf.js
 ** module id = 12
 ** module chunks = 0
 **/